import fetch from '../utils/fetch';

const BaseUrl = process.env.API_BASE || process.env.MONO_BASE;

const getUrl = (path) => `${BaseUrl}${path}`;

export default {
  /**
   * Get themes/social displays
   * @param {Object} query - Query parameters (page, search, tags)
   * @returns {Object} Response with { themes: [], total: 0 }
   */
  async getThemes(query = {}) {
    return fetch(getUrl('/themes'), { query });
  },
};
